// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"EditCasesColumnsDialog_buttonsContainer__Nhtys","gridContainer":"EditCasesColumnsDialog_gridContainer__UOwaj"};